module.exports = "pegasus_template/assets/preview-20.png";